type NotificationPrefetchCommitState = {
    unreadCount: number | null | undefined
    dataUpdatedAtAtStart: number
    dataUpdatedAtNow: number
    badgeEventVersionAtStart?: number
    badgeEventVersionNow?: number
    spaceIdAtStart?: string | number | null
    spaceIdNow?: string | number | null
    isInvalidatedNow?: boolean
    isFetchingNow?: boolean
}

export function canCommitNotificationPrefetch({
    unreadCount,
    dataUpdatedAtAtStart,
    dataUpdatedAtNow,
    badgeEventVersionAtStart = 0,
    badgeEventVersionNow = badgeEventVersionAtStart,
    spaceIdAtStart,
    spaceIdNow = spaceIdAtStart,
    isInvalidatedNow = false,
    isFetchingNow = false,
}: NotificationPrefetchCommitState) {
    return (
        (unreadCount ?? 0) <= 0 &&
        String(spaceIdNow) === String(spaceIdAtStart) &&
        badgeEventVersionNow === badgeEventVersionAtStart &&
        !isInvalidatedNow &&
        !isFetchingNow &&
        dataUpdatedAtNow <= dataUpdatedAtAtStart
    )
}
